// src/cognitoTokenProvider.ts
import { TokenProvider, decodeJWT } from 'aws-amplify/auth';
import { UserManager, WebStorageStateStore } from 'oidc-client-ts';

// Must match the SAME authority/client_id AND storage as your AuthProvider config in index.tsx
const userManager = new UserManager({
  authority: 'https://cognito-idp.us-west-2.amazonaws.com/us-west-2_h7nTBqeQS',
  client_id: '1ltrrg50umnijv7h38aku4ufpr',
  redirect_uri: window.location.origin,
  userStore: new WebStorageStateStore({ store: window.localStorage }), // <-- critical, see note below
});

export const cognitoTokenProvider: TokenProvider = {
  getTokens: async () => {
    const user = await userManager.getUser();
    if (!user?.id_token) return null;

    return {
      idToken: decodeJWT(user.id_token),
      accessToken: decodeJWT(user.access_token),
    };
  },
};